import React from "react";

// Custom.
import Layout from "containers/Layout/Layout";
import Permissions from "pages/acl/Permissions";
import {
  GET_GROUPS_ACL,
  UPDATE_GROUPS_PERMISSIONS,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";

const GroupsPermissions: React.FC = () => {
  return (
    <Layout>
      <div className="vo-global__top-bottom-space">
        <Permissions
          operations={{
            get: GET_GROUPS_ACL,
            update: UPDATE_GROUPS_PERMISSIONS,
          }}
          categories={{
            roles: "groupsRoles",
            permissions: "groupsPermissions",
          }}
          title={I18n.get.group.labels.groupPermissions}
        />
      </div>
    </Layout>
  );
};

export default GroupsPermissions;
